(function (app) {

    app.constant("roles",
        [
            { Label: "CRM User", Value: "Standard" },
            { Label: "CRM Administrator", Value: "Admin" }
        ]);
})(window.app);